import React from 'react'
import { Button, Col, Row, Space, Typography } from 'antd'
import { useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import { track } from '../../../../services/analytics/analytics'

import IntlMessages from '../../../../util/IntlMessages'
import { useCurrency } from '../../../../hooks/use-currency'

import { IImportFooterProps } from '../types'

const { Text } = Typography

const ImportFooter = ({
  userCount,
  importAllUsers,
  disabled,
  onCancel,
  onReviewImport,
  platform,
  upcomingInvoiceInfo,
  currentInvoiceAmount,
  isTrial,
  isFreemium,
}: IImportFooterProps): React.ReactElement => {
  const { formatMessage } = useIntl()
  const { formatPrice } = useCurrency()

  const showBilling = !isTrial && !isFreemium && userCount > 0 && upcomingInvoiceInfo && !upcomingInvoiceInfo.isSameInvoiceAmount

  return (
    <Row justify="space-between" align="middle" className="import-page-footer">
      <Col>
        {showBilling && (
          <Text type="secondary">
            {formatMessage({ id: 'components.importUsersForm.footerBillingIndicator' }, { count: userCount })}
            {currentInvoiceAmount !== undefined && upcomingInvoiceInfo.nextInvoiceAmount > 0 && <> - {formatPrice(Number(upcomingInvoiceInfo.nextInvoiceAmount))}/mo</>}
          </Text>
        )}
      </Col>
      <Col>
        <Space>
          <Button htmlType="button">
            <Link
              to="/app/users"
              onClick={() => {
                track('IMPORT_USERS_CANCEL', { platform })
                onCancel()
              }}
            >
              <IntlMessages id="importUsers.form.backButton" />
            </Link>
          </Button>
          <Button type="primary" disabled={disabled || (userCount === 0 && !importAllUsers)} onClick={onReviewImport}>
            {formatMessage({ id: 'components.importUsersForm.confirmImportUsersModalContentNoOfUsers' }, { noOfUsers: userCount > 0 ? userCount : '' })}
          </Button>
        </Space>
      </Col>
    </Row>
  )
}

export default ImportFooter
